<template>
  <div class="article-area">
    <a-spin :spinning="spinning" v-if="articleItem.id">
      <a-empty v-if="articleItem.auditState !== 'PASS' && !isAuthor && !isAdmin" description="文章不存在"/>
      <div v-else>
        <div class="article-area_title">
          <div style="display:flex;align-items: flex-start;flex:1;overflow-x: hidden;">
            <a-icon v-if="!isArticle && articleItem.bugStatus==='RESOLVED'" type="check-circle" style="color:#09A120;font-size: 31px;margin-right:5px"/>
            <a-icon v-if="!isArticle && articleItem.bugStatus==='UNRESOLVED'" type="clock-circle" style="color:rgba(4,12,44,0.25);font-size: 31px;margin-right:5px"/>
            <div class="article-area_title-text">
              {{ decodeTitle }}
            </div>
            <span 
              v-if="isArticle && articleItem.auditState !== 'PASS' && (isAuthor || isAdmin)"
              class="article-area_title-state" 
              :class="{'stateWait':articleItem.auditState === 'WAIT','stateReject':articleItem.auditState === 'REJECT'}">
              {{ stateMap[articleItem.auditState] }}
            </span>
          </div>
          <div style="display:flex;align-items:center;">
            <a-button v-if="!isArticle && articleItem.bugStatus==='UNRESOLVED' && (isAdmin || isAuthor)" class="article-area_title-button" @click="onClickSolve">
              <a-icon type="check-circle" style="font-size: 16px;"/>标记为已解决
            </a-button>
            <a-button v-if="(isArticle && isAuthor) || (!isArticle && isAuthor && articleItem.bugStatus!=='RESOLVED')" class="article-area_title-button" @click="onClickModify">
              <a-icon type="edit" style="font-size: 16px;"/>修改
            </a-button>
          </div>
        </div>
        <div class="article-area_info">
          <img v-if="articleItem.authorInfo.headUrl" class="article-area_info-head" :src="articleItem.authorInfo.headUrl" alt="头像" @click="routeToUser(articleItem.authorInfo)"/>
          <img v-else class="article-area_info-head" src="@/assets/img/user.png" alt="头像" @click="routeToUser(articleItem.authorInfo)"/>
          <div class="article-area_info-name info-text" @click="routeToUser(articleItem.authorInfo)">{{ articleItem.authorInfo.userName }}</div>
          <div class="article-area_info-time info-text">{{ `发表于${time(articleItem.createTime)}` }}</div>
          <a-icon type="eye" theme="filled" class="article-area_info-icon"/>
          <div class="article-area_info-detail info-text">{{ articleItem.views }}</div>
          <a-icon type="message" theme="filled" class="article-area_info-icon"/>
          <div class="article-area_info-detail info-text">{{ articleItem.comments }}</div>
          <a-icon v-if="articleItem.tagList && articleItem.tagList.length > 0" type="tag" theme="filled" class="article-area_info-icon"/>
          <div v-for="(tag,i) in articleItem.tagList" :key="tag.id">
            <span class="article-area_info-tag info-text" @click="routeToTag(tag)">{{tag.tagName}}</span>
            <span v-if="i < articleItem.tagList.length-1" class="info-text" style="color: rgba(4,12,44,0.45);">，</span>
          </div>
        </div>
        <iframe ref="iframe" width="100%" frameborder="0" :srcdoc="richtextFormat+decodeContent" @load="iframeResize" style="margin-top:10px"></iframe>
        <div v-if="images.length !== 0" style="display:flex;margin-top:10px">
          <span style="white-space: nowrap;">图片：</span>
          <vue-preview :slides="images" class="preview" :share="false"></vue-preview>
        </div>
        <div v-if="articleItem.appendixList && articleItem.appendixList.length !== 0" style="display:flex;margin-top:10px">
          <span style="white-space: nowrap;">附件：</span>
          <upload-file v-model="articleItem.appendixList" class="article-area_upload" :editable="false"></upload-file>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import UploadFile from '@/components/UploadFile.vue'
import { updBugStatus } from '@/utils/api.js'
import { formatTime } from '@/utils'
import xss from 'xss'

export default {
  components: {
    UploadFile
  },
  props: {
    isArticle: {type: Boolean, default:true},
    articleItem: {type: Object, default:()=>{
      return {
        bugStatus: 'UNRESOLVED',
        title: '',
        authorInfo: {
          userId: '',
          headUrl: '',
          userName: ''
        },
        auditState: 'WAIT', //审核状态:WAIT：待审核，PASS：审核通过，REJECT：审核拒绝
        createTime: '',
        views: 0,
        comments: 0,
        tagList: [
        ],
        content: '',
      }
    }}
  },
  data() {
    return {
      stateMap: {
        'WAIT': '待审核',
        'REJECT': '审核拒绝'
      },
      spinning: false,
      richtextFormat: '<style>*{word-break: break-all;}img{max-width: 100%;}</style>'
    }
  },
  computed: {
    tagString() {
      let string = ''
      this.articleItem.tagList.forEach(e => {
        string += `，${e.tagName}`
      })
      string = string.substring(1)
      return string
    },
    images() {
      return this.articleItem.imgList ? this.articleItem.imgList.map(e => {
        return {
          'w':500,
          'h':375,
          src: e.fileUrl,
          msrc: e.fileUrl
        }
      }) : []
    },
    postsId() {
      return this.$route.params.id
    },
    isAuthor() {
      return this.articleItem.authorInfo.userId === this.$store.state.userInfo.uid
    },
    isAdmin() {
      return this.$store.state.userStatic.adminFlag
    },
    decodeTitle() {
      return decodeURI(this.articleItem.title)
    },
    decodeContent() {
      // console.log(xss.whiteList) // 过滤的标签和属性白名单
      return xss(this.articleItem.content)
    }
  },
  methods: {
    iframeResize() {
      const iframe = this.$refs.iframe
      if(!iframe) return false
      const iframeDoc = iframe.contentWindow.document || iframe.contentDocument
      if(iframeDoc) {
        iframe.height = iframeDoc.body.scrollHeight + 40
        iframeDoc.body.style.margin = '0'
      }
    },
    time(time) {
      return formatTime(time)
    },
    onClickModify() {
      this.isArticle ? this.$router.push(`/edit-article/${this.articleItem.id}`) : this.$router.push(`/edit-bug/${this.articleItem.id}`)
    },
    onClickSolve() {
      const params = {
        id: this.articleItem.id,
        bugStatus: 'RESOLVED'
      }
      this.spinning = true
      updBugStatus(params).then(res => {
        this.spinning = false
        if (res.code === 0) {
          this.articleItem.bugStatus = 'RESOLVED'
          this.$message.success('已标记解决')
        } else {
          this.$message.error('标记失败')
        }
      })
    },
    routeToTag(tag) {
      const url = `/tag-article-list/${tag.id}`
      if(this.$route.path === url) return
      this.$router.push(`${url}?tagName=${tag.tagName}`)
    },
    routeToUser(user) {
      const url = `/user-article-list/${user.userId}`
      if(this.$route.path === url) return
      this.$router.push(`${url}?userName=${user.userName}&headUrl=${user.headUrl || ''}`)
    }
  }
}
</script>

<style>
.preview figure {
  margin: 0 10px 10px 0;
}
.preview figure img {
  width: 100px;
  height: 75px;
  object-fit: cover;
}
.pswp__img {
  object-fit: cover;
}
</style>

<style lang="less" scoped>
/deep/.pswp__button--share {
  width: 0;
}
/deep/.my-gallery {
  display: flex;
  flex-wrap: wrap;
}
.info-text {
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 400;
}
.stateWait {
  color: #FAAE14;
  background: #FFF6E5;
  border: 1px solid rgba(252,209,124,1);
}
.stateReject {
  color: #F10000;
  background: #FFEAEA;
  border: 1px solid rgba(255,171,171,1);
}
.article-area {
  padding: 20px 20px 30px 20px;
  width: 100%;
  &_title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    &-text {
      font-size: 20px;
      color: rgba(4,12,44,0.85);
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 400;
      flex: 0 1 auto;
      word-break: break-all;
    }
    &-state {
      margin-left: 10px;
      padding: 2px 10px;
      font-size: 12px;
      letter-spacing: 0;
      text-align: center;
      line-height: 18px;
      font-weight: 400;
      border-radius: 2px;
      white-space: nowrap;
    }
    &-button {
      align-self: flex-end;
      margin-left: 10px;
      display:flex;
      align-items:center;
      padding: 0 10px;
    }
  }
  &_info {
    margin-top: 6px;
    display: flex;
    align-items: center;
    &-head {
      cursor: pointer;
      width: 24px;
      border-radius: 50%;
      border: 1px solid #e5e6e9;
    }
    &-name {
      cursor: pointer;
      margin-left: 10px;
      color: rgba(4,12,44,0.85);
      &:hover {
        color: #1740DC;
      }
    }
    &-time {
      margin-left: 3px;
      color: rgba(4,12,44,0.25);
    }
    &-detail {
      color: rgba(4,12,44,0.45);
    }
    &-tag {
      color: rgba(4,12,44,0.45);
      cursor: pointer;
      &:hover {
        color: #1740DC;
      }
    }
    &-icon {
      margin-right: 12px;
      margin-left: 20px;
      color: #CDCED5;
      font-size: 14px;
    }
  }
  &_content {
    margin-top: 10px;
    color: rgba(4,12,44,0.85);
  }
  &_upload {
    width: 250px; 
    /deep/.file-list-body {
      padding: 0;
    }
  }
}
</style>